import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { countriesActions } from '../../redux/slices/countriesSlice';

export default function useGetAllCountries() {
  const dispatch = useDispatch();

  const fetchAllCountries = useCallback(async () => {
    fetch('https://restcountries.com/v3.1/all?fields=name,cca2')
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) {
          throw new Error('Data is not an array format as expected');
        }
        const countriesOpt = data.map((country: any) => ({
          label: country.name.common,
          value: country.cca2.toLowerCase()
        })).sort((a: any, b: any) => a.label.localeCompare(b.label));
        dispatch(countriesActions.setCountries(countriesOpt));
      })
      .catch((error) => {
        console.error('Error fetching countries:', error);
      });
  }, [dispatch]);

  return {
    fetchData: fetchAllCountries,
  };
}
